import React from 'react';
import { CleanlinessRightPanel } from './CleanlinessRightPanel';
import { FillPowerRightImage } from './FillPowerRightImage';
import { DetailSpeciesText } from './DetailSpeciesText';
import { DetailOriginText } from './DetailOriginText';
import { DetailContentText } from './DetailContentText';
import { DetailTreatmentText } from './DetailTreatmentText';
import { DetailProcessingText } from './DetailProcessingText'; // <-- ADD THIS
import { DetailCertText } from './DetailCertText';
import { isRenu } from '../utils/ui.utils';
import { DetailImpactRightText } from './DetailImpactRightText';
import { DetailCareTitleText } from './DetailCareTitleText';

export const DetailActiveRight = ({ activeSection, data, t, DEV_MODE, showImpact, normalizedFacility, impactData, hideCalculator }) => {
  return (
    <>
      {activeSection === "LOT" && (
        <div className="sticky-desc">
          <p className="spec-title">{t("fillPower")}</p>
          <p className="spec-value">{data.verified_fp}</p>
        </div>
      )}
      <div className="active-desc">
        {activeSection === "CLEANLINESS" && (
          <CleanlinessRightPanel data={data} t={t} />
        )}
        {activeSection === "FP" && (
          <>
            <p className="spec-title">{t("fillPower")}</p>
            <p className="spec-value">{data.verified_fp}</p>
          </>
        )}
        {activeSection === "FP2" && (
          <>
            <p className="spec-title">{t("fpgbStandard")}</p>
            <p className="spec-value">{data.verified_fp_gb}</p>
          </>
        )}
        {activeSection === "ORIGIN" && (
          <DetailOriginText 
            down_type={data.down_type} 
            origin={data.origin ? data.origin[0] : ""} 
            t={t} 
            originExceptionFlag={data.originExceptionFlag} 
          />
        )}
        {activeSection === "SPECIES" && <DetailSpeciesText down_type={data.down_type} t={t} />}
        {activeSection === "CONTENT" && <DetailContentText data={data} t={t} />}
        {activeSection === "TREATMENT" && <DetailTreatmentText data={data} t={t} />}
        {activeSection === "PROCESSING" && <DetailProcessingText normalizedFacility={normalizedFacility} t={t} />} {/* <-- MODIFIED */}
        {activeSection === "CERTIFICATIONS" && (
          <DetailCertText 
            isRsd={data.rsd} 
            isRds={data.rds} 
            isGrs={data.down_type ? isRenu(data.down_type) : false} 
            isTreatment={data.treatment} 
            t={t}
          />
        )}
        {activeSection === "SUSTAINABILITY" && (
          <>
            {showImpact ? (
              <DetailImpactRightText 
                impactData={impactData} 
                hideCalculator={hideCalculator}
                t={t}
              />
            ) : (
              <div className="sticky-desc">
                <p className="spec-title">{t("fillPower")}</p>
                <p className="spec-value">{data.verified_fp}</p>
              </div>
            )}
          </>
        )}
        {activeSection === "CARE" && (
          <DetailCareTitleText t={t} />
        )}
      </div>
    </>
  );
};